module.exports = __webpack_public_path__ + "img/cases-brand-maxam-0.7212dc2a.jpg";